import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, { createContext, ForwardedRef, forwardRef, Suspense, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import tokenService from "../../services/tokenservice";
import { ConfirmacaoProvider } from "../confirmacao/confirmacao";
import "./browser.css";
import PageRender from "./pagerender/pagerender";
import PageBody from "./taskbar/PageBody/pagebody";
import TaskBar from "./taskbar/taskbar";
import { BrowserContextType, MenuItemType } from "./taskbar/taskbartypes.d";
import tema from "./taskbar/tema";

dayjs.locale('pt-br');
dayjs.extend(customParseFormat);
const EasyBrowserContext = createContext<BrowserContextType | undefined>(undefined);

export const useEasyBrowserContext = () => useContext(EasyBrowserContext);

const Browser = forwardRef((_props: unknown, _ref: ForwardedRef<any>) => {

    const pagainaDashboard = {
        id: 'easy.schedule.menu.principal',
        descricao: 'Menu Principal',
        url: '/menu/menu',
        icone: "MenuIcon",
        grupo: ['principal'],
        licenca: ['GERAL']
    }

    const [listaTasks, setListaTasks] = useState<MenuItemType[]>([]);

    const [taskSelecionada, setTaskSelecionada] = useState<MenuItemType | null>(null);

    const [paginasRenderizadas, setPaginasRenderizadas] = useState<any[]>([]);

    const pagesRef = useRef<{ [key: string]: HTMLDivElement | null }>({});

    const [usuario, setUsuario] = useState<Record<string, any>>({});

    const [notaEntrada, setNotaEntrada] = useState<any>(null);

    const [notaSaida, setNotaSaida] = useState<any>(null);

    const [cte, setCte] = useState<any>(null);

    const navigate = useNavigate();

    useEffect(() => {
        tokenService.getToken().then((token) => {
            if (!token) {
                navigate("/login");
            } else {
                carregarUsuario();
            }

        }).catch(() => { navigate("/login"); });
    }, [taskSelecionada]);


    useEffect(() => {
        aplicarVisibilidade();
    }, [taskSelecionada]);


    useEffect(() => {
        abrirPagina(pagainaDashboard);
    }, []);



    const carregarUsuario = async () => {
        const usuario = await tokenService.getUsuario();

        if (!usuario) {
            navigate("/login");
        } else {
            setUsuario(usuario);
        }
    }
    const fecharPagina = (item: MenuItemType) => {

        let listaTasksAtual = listaTasks.filter(itemLista => itemLista.id !== item.id);

        let ultimoItem = listaTasksAtual.at(-1);

        let paginasRenderizadasAtual = paginasRenderizadas.filter(objeto => objeto.props.paginaID !== item.id)
        setPaginasRenderizadas(paginasRenderizadasAtual);

        setTaskSelecionada(ultimoItem || null);

        setListaTasks(listaTasksAtual);
    }

    const getTask = (paginaId : string) => {
        return listaTasks.filter(itemLista => itemLista.id === paginaId);
    }

    const esperar = (tempo: number) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(true);
            }, tempo);
        });
    }
    const abrirPagina = async (item: MenuItemType) => {

        let itemAberto = listaTasks.filter(itemLista => itemLista.id === item.id);




        if (itemAberto.length == 0) {
            setListaTasks([...listaTasks, item]);
            renderizarPagina(item);
        } else if(itemAberto[0].registro !== item.registro) {
            itemAberto[0].registro = item.registro;
        }


        setTaskSelecionada(item);
    }

    const renderizarPagina = (item: MenuItemType) => {
        setPaginasRenderizadas([...paginasRenderizadas, buildPagina(item)]);
    }

    const buildPagina = (item: MenuItemType) => {
        const PageComponent = React.lazy(() => import("../../paginas/gestao" + item.url));

        return (
            <PageRender
                ref={(el) => {
                    if (el) {
                        pagesRef.current[item.id] = el;
                    }
                }}
                paginaID={item.id}
                registro={item.registro}
            >
                <Suspense fallback={<>Carregando...</>}>
                    <ConfirmacaoProvider>
                        <PageComponent />
                    </ConfirmacaoProvider>
                </Suspense>
            </PageRender>
        );
    };

    const aplicarVisibilidade = () => {
        if (taskSelecionada) {
            Object.keys(pagesRef.current).forEach((key) => {
                const el = pagesRef.current[key];
                if (!el) return;

                if (key === taskSelecionada?.id) {
                    el.style.display = '';
                } else {
                    el.style.display = 'none';
                }
            });
        }
    };


    return (
        <EasyBrowserContext.Provider value={{
            listaTasks,
            abrirPagina,
            getTask,
            fecharPagina,
            taskSelecionada,
            paginasRenderizadas,
            usuario,
            notaEntrada,
            setNotaEntrada,
            notaSaida,
            setNotaSaida,
            cte,
            setCte
        }}>

            <ThemeProvider theme={tema} >
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">

                    <TaskBar />
                    <PageBody />

                </LocalizationProvider>
            </ThemeProvider>

        </EasyBrowserContext.Provider>

    );
});

export default Browser;